<mds-dialog dialogTitle="Request Status">
    <mds-dialog-content>
        <div class="pb-medpace">
            <medpace-travel-request-status-change-modal-content
                [formGroup]="formGroup"
                [requestId]="data.requestId"
                (cancel)="cancel()"
                (confirm)="confirm($event)"
            />
        </div>
    </mds-dialog-content>
</mds-dialog>
